export default __webpack_public_path__ + "static/uk-food-025d9bc54f73f5c21e20aab86379111e.jpg";